import * as React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CommentsFilesSection from "./CommentsFilesSection";
import VersionHistorySection from "./VersionHistorySection";
import "./bitacora.scss";

var BitacoraSection = function BitacoraSection(props) {
  var poliza = props.poliza,
      admin = props.admin,
      token = props.token,
      fileTypes = props.fileTypes;
  var queryClient = new QueryClient();
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement("div", {
    className: "bitacora-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("b", null, "Bit\xE1cora / Comentarios")))), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(CommentsFilesSection, {
    polizaId: poliza.id,
    admin: admin,
    token: token,
    fileTypes: fileTypes
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement(VersionHistorySection, {
    polizaId: poliza.id,
    admin: admin,
    token: token
  })))));
};

export default BitacoraSection;